import ExcelJS from 'exceljs/dist/exceljs.bare';

import { Product } from '../../product-center-table-wrapper/product-center-table-wrapper.model';
import { TableTypeEnum } from '../../store/product-center.store.model';

export enum CellFormat {
  NUMBER = 'number',
  CURRENCY = 'currency',
}

export interface TabConfig {
  worksheetName: string;
  fileName: string;
  headers: string[];
  columnWidths: number[];
  getRowData: (product: Product, undReturnData?: CumulativeData) => any[];
  getBenchmarkRowData?: (fundReturnData: CumulativeData) => any[];
  cellFormatters: { index: number; format: CellFormat }[];
  specialFormatting?: (row: ExcelJS.Row) => void;
  renderFooterDisclaimers: boolean;
}

export interface CumulativeData {
  monthEndDate: string | null | undefined;
  fundValue: number | null | undefined;
  benchmarkValue: number | null | undefined;
  benchmarkName: string | null | undefined;
}
